export const validation = {
	// Sale type validation
	saleType: {
		required: "Tipo de venda é obrigatório",
		invalid: "Tipo de venda inválido",
	},
	unitOfMeasure: {
		required: "Unidade de medida é obrigatória",
		requiredForVariable: "Unidade de medida é obrigatória para preço variável",
		invalid: "Unidade de medida inválida",
	},
	price: {
		required: "Preço é obrigatório",
		invalid: "Preço é obrigatório",
		min: "Preço deve ser maior ou igual a 0",
	},
	quantity: {
		required: "Quantidade é obrigatória",
		invalid: "Quantidade inválida",
		min: "Quantidade deve ser maior que 0",
		max: "Quantidade deve ser menor que 10.000",
	},

	// Fiscal data validation
	ncm: {
		required: "NCM é obrigatório",
		invalid: "NCM deve conter entre 4 e 8 dígitos",
	},
	cest: {
		required: "CEST é obrigatório",
		invalid: "CEST deve conter exatamente 7 dígitos",
	},
	fiscalProfile: {
		required: "Perfil fiscal é obrigatório",
		invalid: "Perfil fiscal inválido",
		min: "Perfil fiscal é obrigatório",
	},
	fiscalGroup: {
		required: "Grupo fiscal é obrigatório",
		invalid: "Grupo fiscal inválido",
		min: "Grupo fiscal é obrigatório",
	},

	// General fields
	name: {
		required: "Nome é obrigatório",
		min: "Nome é obrigatório",
		max: "Nome não deve exceder 100 caracteres",
	},
	productType: {
		required: "Tipo do produto é obrigatório",
		invalid: "Tipo do produto inválido",
		min: "Tipo do produto é obrigatório",
	},
	category: {
		required: "Categoria é obrigatória",
		min: "Categoria é obrigatória",
	},
	sku: {
		invalid: "SKU deve conter apenas letras, números, hífens e sublinhados",
	},
	preparationTime: {
		int: "Tempo de preparo deve ser um número inteiro",
		min: "Tempo de preparo deve ser maior que 0",
		max: "Tempo de preparo deve ser menor que 1440 minutos (24 horas)",
	},
	description: {
		max: "Descrição não deve exceder 500 caracteres",
	},

	// Stock validation
	isStockable: {
		required: "Campo obrigatório",
		invalid: "Valor inválido",
	},
	stockControlledBy: {
		required: "Estoque controlado por é obrigatório quando produto é estocável",
		invalid: "Unidade de estoque inválida",
	},
	conversionQuantity: {
		required: "Quantidade de conversão é obrigatória",
		min: "Quantidade deve ser maior que 0",
		max: "Quantidade de conversão deve ser menor que 10.000",
	},
	conversionUnit: {
		required: "Unidade de conversão é obrigatória",
		invalid: "Unidade de conversão inválida",
	},

	// Image validation
	image: {
		required: "Imagem é obrigatória",
		invalid: "Imagem inválida",
	},

	// Mountable product validation
	mountable: {
		title: {
			required: "Título da etapa é obrigatório",
			min: "Título da etapa é obrigatório",
		},
		pricing: {
			required: "Método de precificação é obrigatório",
			invalid: "Método de precificação inválido",
		},
		min: {
			required: "Valor mínimo é obrigatório",
			minValue: "Valor mínimo deve ser maior ou igual a 0",
		},
		max: {
			required: "Valor máximo é obrigatório",
			minValue: "Valor máximo deve ser maior que 0",
			minGreaterThanMin: "Valor máximo deve ser maior ou igual ao mínimo",
		},
		items: {
			min: "Deve haver pelo menos um item na etapa",
		},
		item: {
			productId: {
				required: "Item é obrigatório",
				min: "Item é obrigatório",
				duplicate: "Este item já foi adicionado nesta etapa",
			},
			price: {
				min: "Preço deve ser maior ou igual a 0",
			},
			storageCount: {
				required: "Quantidade abatida é obrigatória",
				minValue: "Quantidade abatida deve ser maior que 0",
			},
		},
	},
};
